import React from 'react'
import { Box, Typography } from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'

import { DamageCard } from '../MoveOut/DamageCard'
import { DamageDetail } from '../MoveOut/types'
import { formatDamageTotal } from './inspectionUtils'

interface MoveOutDamagesSectionProps {
    damages: DamageDetail[]
    totalDamages: string
}

export const MoveOutDamagesSection: React.FC<MoveOutDamagesSectionProps> = ({
    damages,
    totalDamages,
}) => {
    if (damages.length === 0) {
        return (
            <Box
                sx={{
                    bgcolor: 'rgba(138, 142, 140, 0.16)',
                    borderRadius: 2,
                    border: '1px solid rgba(255,255,255,0.1)',
                    p: 2,
                }}
            >
                <Typography variant="body2" sx={{ color: '#94a3b8' }}>
                    No damages recorded.
                </Typography>
            </Box>
        )
    }

    return (
        <Box
            sx={{
                border: '1px solid rgba(255, 255, 255, 0.08)',
                borderRadius: 2,
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 2,
                    py: 1.5,
                    backgroundColor: 'rgba(239, 68, 68, 0.08)',
                }}
            >
                <WarningIcon sx={{ fontSize: 18, color: '#ef4444' }} />
                <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: '#ef4444' }}
                >
                    Damages ({damages.length})
                </Typography>
            </Box>
            {damages.map((damage) => (
                <DamageCard key={damage.id} damage={damage} />
            ))}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    px: 2,
                    py: 1.5,
                    borderTop: '1px solid rgba(255, 255, 255, 0.06)',
                    backgroundColor: 'rgba(255, 255, 255, 0.02)',
                }}
            >
                <Typography variant="body2" sx={{ fontWeight: 600, color: '#fff' }}>
                    Total Damages
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 700, color: '#ef4444' }}>
                    {formatDamageTotal(totalDamages)}
                </Typography>
            </Box>
        </Box>
    )
}
